import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from '../../auth/user.service';

@Component({
	selector: 'app-manage-device-btn',
	templateUrl: './manage-device-btn.component.html',
	styleUrls: ['./manage-device-btn.component.css']
})
export class ManageDeviceBtnComponent implements OnInit {

	currentUser: any = {};
	@Input() selectedDevices = [];
	@Input() type: String = 'charger';
	@Input() twoLines: Boolean = false;
	@Input() hasBottomMargin: Boolean = true;
	@Input() manageChargerBtnMarginClass: string = "";
	@Input() manageChargerDatesBtnMarginClass: string = "";

	chargerEditBtnTxt	= ["g.manage", "device.charger", "time.dates"];
	chargerReqBtnTxt	= ["charger.request_charger", "charger.management_change"];
	chargerReqDatesBtnTxt	= ["g.request", "device.charger", "time.dates"];
	battviewEditBtnTxt	= ["g.manage", "BATTView", "time.dates"];
	battviewReqBtnTxt	= ["device.request_battview", "charger.management_change"];
	battviewReqDatesBtnTxt	= ["g.request", "BATTView", "time.dates"];
	truckviewEditBtnTxt	= ["g.manage", "TRUCKView", "time.dates"];
	truckviewReqBtnTxt	= ["g.request_truckview", "charger.management_change"];
	truckviewReqDatesBtnTxt	= ["g.request", "TRUCKView", "time.dates"];
	// PolarLink (Plink) button text (using literal like BATTView style so translations fallback to key)
	plinkEditBtnTxt	= ["g.manage", "PolarLink", "time.dates"];
	plinkReqBtnTxt	= ["device.request_plink", "charger.management_change"];
	plinkReqDatesBtnTxt	= ["g.request", "PolarLink", "time.dates"];
	btnText = [];
	btnDatesText = [];
	manageDatesAccess: boolean = false;

	constructor(private userService: UserService, private router: Router) { }

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUser();
		if(this.type == 'charger') {

			if(this.currentUser['allowToChangeDeviceAttribute']) {
				this.btnText = [this.chargerEditBtnTxt[0], this.chargerEditBtnTxt[1]];
				this.btnDatesText = [this.chargerEditBtnTxt[0], this.chargerEditBtnTxt[1], this.chargerEditBtnTxt[2]];
			} else {
				this.btnText = [this.chargerReqBtnTxt[0], this.chargerReqBtnTxt[1]];
				this.btnDatesText = [this.chargerReqDatesBtnTxt[0], this.chargerReqDatesBtnTxt[1], this.chargerReqDatesBtnTxt[2]];
				this.twoLines = true;
			}
		} else if (this.type == 'battview') {
			//battview
			if(this.currentUser['allowToChangeDeviceAttribute']) {
				this.btnText = [this.battviewEditBtnTxt[0], this.battviewEditBtnTxt[1]];
				this.btnDatesText = [this.battviewEditBtnTxt[0], this.battviewEditBtnTxt[1], this.battviewEditBtnTxt[2]];
			} else {
				this.btnText = [this.battviewReqBtnTxt[0], this.battviewReqBtnTxt[1]];
				this.btnDatesText = [this.battviewReqDatesBtnTxt[0], this.battviewReqDatesBtnTxt[1], this.battviewReqDatesBtnTxt[2]];
			}
		} else if (this.type == 'truckview') {
			//truckview
			if(this.currentUser['allowToChangeDeviceAttribute']) {
				this.btnText = [this.truckviewEditBtnTxt[0], this.truckviewEditBtnTxt[1]];
				this.btnDatesText = [this.truckviewEditBtnTxt[0], this.truckviewEditBtnTxt[1], this.truckviewEditBtnTxt[2]];
			} else {
				this.btnText = [this.truckviewReqBtnTxt[0], this.truckviewReqBtnTxt[1]];
				this.btnDatesText = [this.truckviewReqDatesBtnTxt[0], this.truckviewReqDatesBtnTxt[1], this.truckviewReqDatesBtnTxt[2]];
			}
		} else if (this.type == 'plink') {
			// PolarLink
			if(this.currentUser['allowToChangeDeviceAttribute']) {
				this.btnText = [this.plinkEditBtnTxt[0], this.plinkEditBtnTxt[1]];
				this.btnDatesText = [this.plinkEditBtnTxt[0], this.plinkEditBtnTxt[1], this.plinkEditBtnTxt[2]];
			} else {
				this.btnText = [this.plinkReqBtnTxt[0], this.plinkReqBtnTxt[1]];
				this.btnDatesText = [this.plinkReqDatesBtnTxt[0], this.plinkReqDatesBtnTxt[1], this.plinkReqDatesBtnTxt[2]];
			}
		}
		this.manageDatesAccess = this.userService.hasAccessFunction('accounting') ||
			this.userService.hasAccessFunction('act_intelligent_management') ||
			this.userService.hasAccessFunction('admin_act_intelligent') ||
			this.userService.hasAccessFunction('users_function_management');
	}

	goToManageDevicePage() {
		this.router.navigate(['/devices', 'devices-management', this.type, this.selectedDevices.join(',')]);
	}
	goToManageDatesDevicePage() {
		this.router.navigate(['/devices', 'devices-dates-management', this.type, this.selectedDevices.join(',')]);
	}
}
